// extracted by mini-css-extract-plugin
var _1 = "pagination__page__M8yJO";
var _2 = "pagination__previous-page-icon__O8PvY";
export { _1 as "paginationPage", _2 as "paginationPreviousPageIcon" }
